import React from 'react';
import { FiClock, FiShield, FiUsers, FiMessageSquare } from 'react-icons/fi';

const items = [
  {
    icon: <FiClock className="h-5 w-5" />,
    title: '24/7 availability',
    text: 'Request support any time through our service desk.',
  },
  {
    icon: <FiShield className="h-5 w-5" />,
    title: 'Secure handling',
    text: 'Your request details are processed through a protected flow.',
  },
  {
    icon: <FiUsers className="h-5 w-5" />,
    title: 'Partner-trained agents',
    text: 'Experienced teams handle subscription and billing questions.',
  },
  {
    icon: <FiMessageSquare className="h-5 w-5" />,
    title: 'Clear communication',
    text: 'Straightforward answers, quick follow-up, and guided next steps.',
  },
];

export default function TrustBar() {
  return (
    <section className="relative -mt-8 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-7xl gap-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.22)] md:grid-cols-2 xl:grid-cols-4 xl:p-6">
        {items.map(item => (
          <div key={item.title} className="flex gap-4 rounded-2xl border border-slate-100 bg-slate-50/80 p-4">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-2xl bg-indigo-600 text-white">
              {item.icon}
            </div>
            <div>
              <h3 className="text-sm font-semibold text-slate-900">{item.title}</h3>
              <p className="mt-1 text-sm leading-6 text-slate-600">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}